module.exports = __webpack_public_path__ + "static/media/carte-guinee.7253aaa1.svg_old";